export function allConnected(...nodes: (Node | undefined | null)[]): boolean {
    for (const node of nodes) {
        if (!node || !node.isConnected) {
            return false;
        }
    }
    return true;
}
